module.exports = __webpack_public_path__ + "img/tag_FX_USD.23eb58a7.png";